"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var GeneralSettings_1 = require("../../../../constants/GeneralSettings");
var loginSlice_1 = require("../../../../features/login/loginSlice");
var Routes_1 = require("../../../../constants/Routes");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Links = function (_a) {
    var onDismiss = _a.onDismiss;
    var history = react_router_dom_1.useHistory();
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var links = react_1.useMemo(function () {
        return GeneralSettings_1.PROFILE_LINKS.map(function (item) { return (__assign(__assign({}, item), { title: t(item.title) })); });
    }, []);
    var handleClick = function (event) {
        event.preventDefault();
        onDismiss();
        dispatch(loginSlice_1.logout());
        history.push(Routes_1.Routes.Home.path);
    };
    return (react_1.default.createElement("ul", { className: styles_module_scss_1.default.bottom_sheet_menu }, links.map(function (link, index) {
        var isLogOutItem = link.key === 'logout';
        return (react_1.default.createElement("li", { key: index, className: styles_module_scss_1.default.bottom_sheet_menu_item },
            react_1.default.createElement(react_router_dom_1.Link, { to: isLogOutItem ? '/' : "/" + link.url, onClick: function (event) {
                    return isLogOutItem ? handleClick(event) : onDismiss();
                } },
                react_1.default.createElement("i", { className: classnames_1.default('cm-icon', link.icon) }),
                link.title,
                link.span ? (react_1.default.createElement("span", { className: styles_module_scss_1.default.counter }, "15")) : null)));
    })));
};
exports.default = react_1.memo(Links);
